import React from "react";
import clsx from "clsx";
import { BooksIcon } from "Components/Icons/Documents/BooksIcon";
import { CheckIcon } from "Components/Icons/Arrows/CheckIcon";
import { ClipboardListIcon } from "Components/Icons/Documents/ClipboardListIcon";
import { ClockIcon } from "Components/Icons/Miscellaneous/ClockIcon";
import "./CourseTrackingCard.scss";

/**
 * Componente card que da seguimiento del curso
 * @param disabled - Indica si se desahabilita el componente
 * @param {Object} props - Propiedades del componente
 * @param {"default"|"survey"|"neutral"} [props.variant="default"] - Variante del componente
 * @param {string} [props.title="Título del curso"] - Título del curso
 * @param {boolean} [props.completed=false] - Indica si el curso está completado
 * @param {boolean} [props.active=false] - Indica si el curso está activo
 * @param {string} [props.duration="00:00 minutos"] - Duración del curso
 * @param {Function} [props.onClick] - Función callback al hacer clic
 * @param {string} [props.className=""] - Clases CSS adicionales
 * @returns {JSX.Element} Componente card de seguimiento de curso
 */
export const CourseTrackingCard = ({
  variant = "default",
  title = "Título del curso",
  completed = false,
  active = false,
  duration = "00:00 minutos",
  onClick,
  className = "",
  disabled = false,
  ...props
}) => {
  const isSurvey = variant === "survey";
  const isNeutral = variant === "neutral";
  const isDefaultOrNeutral = variant === "default" || variant === "neutral";

  return (
    <div
      className={clsx(
        "course-tracking-card",
        {
          "course-tracking-card--active": active,
          "course-tracking-card--disabled": disabled,
        },
        className
      )}
      {...props}
      onClick={disabled ? undefined : onClick}
    >
      <div
        className={clsx({
          "course-tracking-card__image": true,
          "course-tracking-card__image--neutral": isNeutral,
        })}
      >
        <div
          className={clsx({
            "course-tracking-card__icon": true,
            "course-tracking-card__icon--neutral": isNeutral,
          })}
        >
          {isSurvey && <ClipboardListIcon />}
          {isDefaultOrNeutral && <BooksIcon />}
        </div>
      </div>

      <div className="course-tracking-card__content">
        <h3
          className={clsx({
            "course-tracking-card__title": true,
            "course-tracking-card__title--neutral": isNeutral,
          })}
        >
          {isSurvey && "Encuesta de satisfacción"}
          {isDefaultOrNeutral && title}
        </h3>

        <div className="course-tracking-card__status">
          {isSurvey && (
            <CheckIcon
              className={clsx({
                "course-tracking-card__status--completed": completed,
              })}
            />
          )}
          {variant === "default" && (
            <CheckIcon
              className={clsx({
                "course-tracking-card__status--completed": completed,
              })}
            />
          )}
          {variant === "neutral" &&
            (completed ? (
              <CheckIcon className="course-tracking-card__status--completed" />
            ) : (
              <ClockIcon className="course-tracking-card__status--clock" />
            ))}

          <span className="course-tracking-card__status--text">
            {isSurvey && "Último paso"}
            {variant === "neutral" &&
              (completed ? "Curso completado" : duration)}
            {variant === "default" && (completed ? "Completado" : "Pendiente")}
          </span>
        </div>
      </div>
    </div>
  );
};
